import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Box,
  Typography,
  FormControlLabel,
  Radio,
} from "@mui/material";
import axios from "axios";
import { VAVE, UPLOAD2B2FILE } from "../../../Pages/AppConstant";
import loadergif from "../../../assets/images/BG-switch loader_2.gif";

const AlertDialogForm = ({ response, setRefreshApi }) => {
  console.log("Complete response data:", response);
  const [selectedManufacturingSubField, setSelectedManufacturingSubField] =
    useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleManufacturingSubFieldChange = (event) => {
    setSelectedManufacturingSubField(event.target.value);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const uploadExcel = (request) => async (event) => {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    // Reset file input
    event.target.value = "";

    const validTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    if (!validTypes.includes(file.type)) {
      alert("Please upload only Excel files (.xls or .xlsx).");
      return;
    }

    const expectedName = `Idea_${request.idea_unique_id}_Report`;
    const fileNameWithoutExt = file.name.replace(/\.xlsx?$/i, "");

    if (fileNameWithoutExt !== expectedName) {
      alert(`Please upload file with name: ${expectedName}.xlsx`);
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      alert("Upload size should not exceed 5 MB.");
      return;
    }
    setSelectedFile(file);
    // setUploadFile(file);
  };

  const upload2b2File = async (file, request) => {
    const formData = new FormData();
    formData.append("filepath", file);
    formData.append("type", "Excel");
    formData.append("idea_id", request.ideaid);
    formData.append("manufac", selectedManufacturingSubField);
    formData.append("emp_id", localStorage.getItem("empid"));

    if (selectedManufacturingSubField === "Ennore") {
      //// dev
      // formData.append("il2_manuf_empid", "FL_0004");
      // formData.append("il2_manuf_name", "FL_0004_name");
      // formData.append("il2_manuf_emailid", "diwakar.b@switchmobilityev.com");
      // formData.append("il2_manuf_location", selectedManufacturingSubField);
      // formData.append("il2_manuf_status", "inprogress");

      //// production
      formData.append("il2_manuf_empid", "300665");
      formData.append("il2_manuf_name", "Neeraja Kota");
      formData.append("il2_manuf_emailid", "Kota.Neeraja@switchmobilityev.com");
      formData.append("il2_manuf_location", selectedManufacturingSubField);
      formData.append("il2_manuf_status", "inprogress");
    } else if (selectedManufacturingSubField === "Hosur") {
      ////dev
      // formData.append("il2_manuf_empid", "FL_0005");
      // formData.append("il2_manuf_name", "FL_0005_name");
      // formData.append("il2_manuf_emailid", "sathish.m@switchmobilityev.com");
      // formData.append("il2_manuf_location", selectedManufacturingSubField);
      // formData.append("il2_manuf_status", "inprogress");

      //// production
      formData.append("il2_manuf_empid", "300016");
      formData.append("il2_manuf_name", "Parthiban M");
      formData.append("il2_manuf_emailid", "parthiban.m@switchmobilityev.com");
      formData.append("il2_manuf_location", selectedManufacturingSubField);
      formData.append("il2_manuf_status", "inprogress");
      // formData.append("il2_manuf_empid", "300368");
      // formData.append("il2_manuf_name", "Baskaran N");
      // formData.append("il2_manuf_emailid", "Baskaran.N@switchmobilityev.com");
      // formData.append("il2_manuf_location", selectedManufacturingSubField);
      // formData.append("il2_manuf_status", "inprogress");
    } else if (selectedManufacturingSubField === "Bus Body") {
      ////dev
      // formData.append("il2_manuf_empid", "FL_0006");
      // formData.append("il2_manuf_name", "FL_0006_name");
      // formData.append(
      //   "il2_manuf_emailid",
      //   "HTL_Ramkumar.R@switchmobilityev.com"
      // );
      // formData.append("il2_manuf_location", selectedManufacturingSubField);
      // formData.append("il2_manuf_status", "inprogress");

      //// production
      formData.append("il2_manuf_empid", "300450");
      formData.append("il2_manuf_name", "Kesavan S");
      formData.append("il2_manuf_emailid", "Kesavan.s@switchmobilityev.com");
      formData.append("il2_manuf_location", selectedManufacturingSubField);
      formData.append("il2_manuf_status", "inprogress");
    }

    try {
      setIsLoading(true);
      await axios.post(VAVE + UPLOAD2B2FILE, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setSelectedFile(file);
      alert("File uploaded successfully!");
    } catch (error) {
      console.error("Upload error:", error);
      alert("Upload failed. Please try again.");
    } finally {
      setIsLoading(false);
      setRefreshApi(true);
    }
  };

  const manufacturingSubFields = [
    { value: "1", label: "Ennore" },
    { value: "2", label: "Hosur" },
    { value: "3", label: "Bus Body" },
  ];

  const isFormValid = selectedManufacturingSubField && selectedFile;

  return (
    <Box sx={{ padding: "20px", maxWidth: "500px", margin: "0 auto" }}>
      {isLoading ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div className="loadergif">
            <img src={loadergif} alt="Loading..." />
          </div>
        </div>
      ) : (
        ""
      )}
      {/* Manufacturing Subfield Selection */}
      <FormControl
        fullWidth
        sx={{ marginBottom: 3 }}
        error={!selectedManufacturingSubField}
      >
        <InputLabel id="manufacturing-subfield-label">
          Select Manufacturing Option*
        </InputLabel>
        <Select
          labelId="manufacturing-subfield-label"
          id="manufacturing-subfield-select"
          value={selectedManufacturingSubField}
          label="Select Manufacturing Option*"
          onChange={handleManufacturingSubFieldChange}
        >
          {manufacturingSubFields.map((subField) => (
            <MenuItem key={subField.value} value={subField.label}>
              {subField.label}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>
          {!selectedManufacturingSubField
            ? "Please select one Manufacturing option"
            : "Selected: " +
              manufacturingSubFields.find(
                (f) => f.value === selectedManufacturingSubField
              )?.label}
        </FormHelperText>
      </FormControl>

      {/* Upload Section */}
      <Box sx={{ marginTop: "20px" }}>
        <Typography variant="body1" sx={{ display: "block", marginBottom: 1 }}>
          Upload*
        </Typography>
        {selectedFile === null && (
          <input
            type="file"
            onChange={uploadExcel(response)}
            id="excelUpload"
            accept=".xlsx,.xls"
            style={{ marginBottom: "16px", width: "100%" }}
            disabled={isLoading}
          />
        )}

        {selectedFile && (
          <Typography
            variant="body2"
            color="success.main"
            sx={{ marginBottom: 2 }}
          >
            ✓ File uploaded: {selectedFile.name}
          </Typography>
        )}

        <Box sx={{ textAlign: "right" }}>
          <Button
            variant="outlined"
            color="error"
            onClick={() => upload2b2File(selectedFile, response)}
            disabled={isLoading || !isFormValid}
            // startIcon={isLoading ? <CircularProgress size={16} /> : null}
          >
            Done
          </Button>
        </Box>
      </Box>

      {/* Alert Dialog */}
      <Dialog open={openAlert} onClose={handleCloseAlert}>
        <DialogTitle>Missing Required Field</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please select a Manufacturing option before submitting.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAlert} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AlertDialogForm;
